import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { IconButton } from 'shared-components';
import { GuestName, T } from 'containers';
import { AppText } from 'domain/appText';

const StyledIconButton = styled(IconButton)`
  border: none;
  opacity: 1;
  &:hover {
    opacity: 0.5;

    svg{
      fill: #547799;
      stroke: #547799;
    }
  }
`;

const StyledGuestName = styled(GuestName)`
  display: inline-block;
  position: relative;
  border-radius: 4px;
  border: 1px solid #ecf2f8;
  margin: 2px 5px;
  padding: 5px 30px 5px 10px;

  ${StyledIconButton} {
    position: absolute;
    right: 0;
    top: 0;
    vertical-align: middle;
    width: 28px;
    height: 28px;
    border: 0;

    svg{
      width: 20px;
      height: 20px;
      margin: 4px;
    }
  }
`;

class GuestInCabin extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    onRemoveGuest: PropTypes.func,
  }
  static defaultProps = {
    onRemoveGuest: () => {},
  }

  onRemoveClick = () => {
    this.props.onRemoveGuest(this.props.id);
  }
  render() {
    const { id, className } = this.props;

    return (
      <T
        text={AppText.RemoveGuestTitle}
        render={removeGuestTitle => (
          <StyledGuestName key={id} id={id} className={className} >
            <StyledIconButton id={id} icon="close" onClick={this.onRemoveClick} palette="white" transparent iconHeight={30} title={removeGuestTitle} />
          </StyledGuestName>
        )}
      />
    );
  }
}


export default GuestInCabin;



// WEBPACK FOOTER //
// ./src/components/molecules/GuestInCabin/index.js